<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>职员管理</el-breadcrumb-item>
          <el-breadcrumb-item>职员列表</el-breadcrumb-item>
        </el-breadcrumb>
       <el-form size="mini" label-width="130px" :model="where" class="demo-form-inline">
  <el-row>
    <el-col :span="6">
       <el-form-item label="姓名">
    <el-input v-model="where.name"></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="6">
   <el-form-item label="手机号">
    <el-input v-model="where.mobile"></el-input>
  </el-form-item>
    </el-col>
     <el-col :span="6">
       <el-form-item label="用户名">
      <el-input v-model="where.username"></el-input>
  </el-form-item>
     </el-col>
       <el-col :span="6">
       <el-form-item label="权限组">
       <el-select v-model="where.roleid" clearable placeholder="请选择">
    <el-option
      v-for="item in roles"
      :key="item.innerid"
      :label="item.name"
      :value="item.innerid">
    </el-option>
  </el-select>
  </el-form-item>
     </el-col>
       <el-col :span="6">
         <el-form-item label="">
         
         </el-form-item>
       </el-col>
       <el-col :span="6"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="6"> <el-form-item label=""></el-form-item></el-col>
       <el-col :span="6" style="text-align:right">
       
        <el-button size="small" type="primary" @click="searchUser()">查询</el-button>
          <el-divider v-if="user.isadmin||($store.state.permission.CreateUser&&$store.state.permission.CreateUser.show)" direction="vertical"></el-divider>
          <el-button  v-if="user.isadmin||($store.state.permission.CreateUser&&$store.state.permission.CreateUser.show)" title="新增" style="background:linear-gradient(to bottom,rgb(90, 157, 171),#0093a8);color:#ffffff" size="small" icon="el-icon-plus" @click="createUser()"></el-button>
     
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
          ></el-table-column>
           <el-table-column prop="name" label="姓名">
            <template slot-scope="scope">
              <span>{{scope.row.name}}</span>
              </template> </el-table-column>
          <el-table-column prop="username" label="用户名">
            <template slot-scope="scope">
              <span>{{scope.row.username}}</span><span v-if="!scope.row.isadmin">@{{factorycode}}</span>
              </template> </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="150"> </el-table-column>
           <el-table-column prop="rolename" label="权限组" width="150"> </el-table-column>
          <el-table-column label="操作" column-key="opt" >
            <template  slot-scope="scope"   v-if="!scope.row.isadmin">
               <el-button
                size="mini"
                type="text"
                @click="update(scope.row)"
                v-if="user.isadmin||($store.state.permission.EditUser&&$store.state.permission.EditUser.show)"
                >修改</el-button
              >
               <el-divider   v-if="user.isadmin||($store.state.permission.PasswordUser&&$store.state.permission.PasswordUser.show)" direction="vertical"></el-divider>
             <el-button
             v-if="user.isadmin||($store.state.permission.PasswordUser&&$store.state.permission.PasswordUser.show)"
                size="mini"
                type="text"
                @click="resetPassword(scope.row)"
                >重置密码</el-button
              >
              <el-divider   v-if="user.isadmin||($store.state.permission.DataPermission&&$store.state.permission.DataPermission.show)" direction="vertical"></el-divider>
             <el-button
             v-if="user.isadmin||($store.state.permission.DataPermission&&$store.state.permission.DataPermission.show)"
                size="mini"
                type="text"
                @click="dataPermission(scope.row)"
                >网关权限</el-button
              >
               <el-divider v-if="user.isadmin||($store.state.permission.DelUser&&$store.state.permission.DelUser.show)" direction="vertical"></el-divider>
              <el-button
              v-if="user.isadmin||($store.state.permission.DelUser&&$store.state.permission.DelUser.show)"
              size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

    <el-row style="height:40px">
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'UserList',
  data () {
    return {
      factory:{},
      user:{},
      roles:[],
      tabledata: [],
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      where: {
        name:'',
        username:'',
        mobile: '',
        roleid:''
      },
    }
  },
  mounted: function () {
    var self = this
    let user = window.localStorage.getItem('customer')
    if (user) {
      this.factorycode=JSON.parse(user).factorycode
      this.user=JSON.parse(user)
      self.searchUser()

  
         Vue.axios
          .post('/factory/role/all', {})
          .then((res) => {
            if (res.data.errcode == 0) {
              self.roles = res.data.msgbody
            }
          })
       
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createUser () {
      this.$router.push({name: 'CreateUser'})
    },
    update(row){
      this.$router.push({name: 'EditUser',params:{innerid:row.innerid}})
    },
    dataPermission(row){
      this.$router.push({name: 'DataPermission',params:{innerid:row.innerid}})
    },
    searchUser () {
      var self = this
        Vue.axios
          .post('/factory/user/list/search', {
            where: self.where,
            pageset: self.pageset
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.tabledata = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
        Vue.axios
          .post('/factory/user/list/count/search', {
            where: self.where
          })
          .then((res) => {
            if (res.data.errcode == 0) {
              self.totalsize = res.data.msgbody
            } else {
              this.$message({
                showClose: true,
                message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                type: 'error'
              })
            }
          })
      
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchUser()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchUser()
    },
    handleDelete (row) {
      this.$confirm(
        '确定删除职员' + row.name + '(' + (row.username || '-') + ')？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          Vue.axios
            .post('/factory/user/del', {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchUser()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    resetPassword (row) {
      this.$prompt('请输入新密码', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        if (value) {
          var self = this
          Vue.axios
            .post('/factory/user/password/reset/edit', {
              innerid: row.innerid,
              password: hex_md5(value)
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '修改密码成功：' + value
                })
                self.searchUser()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/User/Index.vue